<ng-template #thisModalForm role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="thisFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="thisFormSubmitAttempt()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      @if (progressInformationShow) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                <span [innerHtml]="progressInformation"></span>
              </div>
            </div>
          </div>
        </div>
      }
              
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="usageTariffId-field" class="form-label text-right">Usage Tariff</label>
            <select
              class="form-select"
              name="usageTariffId-field"
              id="usageTariffId-field"
              formControlName="usageTariffId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['usageTariffId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("usageTariffId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="mappedZoneId-field" class="form-label text-right">Mapped Zone</label>
            <select
              class="form-select"
              name="mappedZoneId-field"
              id="mappedZoneId-field"
              formControlName="mappedZoneId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['mappedZoneId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("mappedZoneId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="dataChargeWeightId-field" class="form-label text-right">Charge Per</label>
            <select
              class="form-select"
              name="dataChargeWeightId-field"
              id="dataChargeWeightId-field"
              formControlName="dataChargeWeightId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['dataChargeWeightId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("dataChargeWeightId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-4">
          <div class="mb-3">
            <label for="dataChargePerX-field" class="form-label">Charge (GBP)</label>
            <div class="input-group">
              <span class="input-group-text">£</span>
              <input type="number" id="dataChargePerX-field" class="form-control text-end" placeholder="" formControlName="dataChargePerX" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['dataChargePerX'].errors }" />
              <div class="invalid-feedback">A value is required</div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label for="dataChargePerXEur-field" class="form-label">Charge (EUR)</label>
            <div class="input-group">
              <span class="input-group-text">€</span>
              <input type="number" id="dataChargePerXEur-field" class="form-control text-end" placeholder="" formControlName="dataChargePerXEur" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['dataChargePerXEur'].errors }" />
              <div class="invalid-feedback">A value is required</div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label for="dataChargePerXUsd-field" class="form-label">Charge (USD)</label>
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" id="dataChargePerXUsd-field" class="form-control text-end" placeholder="" formControlName="dataChargePerXUsd" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['dataChargePerXUsd'].errors }" />
              <div class="invalid-feedback">A value is required</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <app-dropdown-date
              [initialDate]="startDate"
              title="Start Date"
              (selectOnChangeEvent)="startDateChanged($event)"
            ></app-dropdown-date>
          </div>
        </div>
      
        <div class="col-6">
          <div class="mb-3">
            <app-dropdown-date
              [allowUndefinedInitialDate]="true"
              [initialDate]="endDate"
              title="End Date"
              (selectOnChangeEvent)="endDateChanged($event)"
            ></app-dropdown-date>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-12">
          <div class="form-check form-switch form-switch-md">
            <label class="form-check-label" for="uplift-field">Uplift</label>
            <input class="form-check-input" type="checkbox" role="switch" id="uplift-field" formControlName="uplift">
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-12">
          <div class="form-check form-switch form-switch-md">
            <label class="form-check-label" for="active-field">Active</label>
            <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active">
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="thisFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalFormClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
